// Raw CSS string mirror of `quittanceIndemnite.css` for injection into the
// print iframe (CRA 5 does not support `?raw` imports without ejecting).
// Keep this module in sync with quittanceIndemnite.css whenever styles change.
export default `
.quittance-container {
    width: 210mm;
    min-height: 297mm;
    background: white;
    font-family: Arial, Helvetica, sans-serif;
    font-size: 13px;
    color: #000;
    box-sizing: border-box;
    padding: 12mm 15mm;
    line-height: 1.5;
}

.quittance-header {
    display: flex;
    align-items: center;
    gap: 16px;
    margin-bottom: 10px;
}

.quittance-header-bureau {
    flex: 1 1 0;
    min-width: 0;
}

.quittance-header-reglement {
    flex: 1 1 0;
    min-width: 0;
    text-align: right;
    font-size: 11px;
    color: #333;
}

.quittance-header-text-main {
    font-weight: 700;
    font-size: 15px;
    color: #1a6b3c;
    letter-spacing: 0.5px;
}

.quittance-header-text-sub {
    font-size: 12px;
    color: #555;
    margin-top: 2px;
}

.quittance-separator {
    border: none;
    border-bottom: 3px solid #1a6b3c;
    margin: 0 0 14px 0;
}

.quittance-title-wrapper {
    text-align: center;
    margin-bottom: 16px;
}

.quittance-title {
    font-size: 15px;
    font-weight: 700;
    letter-spacing: 2px;
    margin: 0;
    text-transform: uppercase;
}

.quittance-block {
    margin-bottom: 12px;
}

.quittance-block-title {
    margin: 0;
    padding: 5px 10px;
    font-size: 12px;
    font-weight: 700;
    letter-spacing: 0.5px;
    color: #fff;
    background: #1a6b3c;
    text-transform: uppercase;
}

.quittance-ref-table,
.quittance-payment-table {
    width: 100%;
    border-collapse: collapse;
    font-size: 13px;
    table-layout: auto;
}

.quittance-ref-table td {
    padding: 6px 10px;
    border: 0.5px solid #a7f3d0;
    vertical-align: middle;
    font-size: 13px;
}

.quittance-ref-label {
    width: 42%;
    font-weight: 600;
    background: #f0fdf4;
}

.quittance-ref-value {
    font-weight: 400;
}

.quittance-payment-table th,
.quittance-payment-table td {
    padding: 6px 8px;
    border: 0.5px solid #a7f3d0;
    vertical-align: middle;
    font-size: 12px;
    text-align: left;
}

.quittance-payment-table thead tr {
    background: #f0fdf4;
}

.quittance-payment-table th {
    font-weight: 700;
    font-size: 11px;
    text-transform: uppercase;
}

.quittance-totaux {
    display: flex;
    gap: 16px;
    align-items: start;
}

.quittance-encadre {
    flex: 1 1 0;
    min-width: 0;
    border: 0.5px solid #a7f3d0;
}

.quittance-encadre--total {
    flex: 0 0 210px;
}

.quittance-encadre-titre {
    background: #1a6b3c;
    color: #fff;
    font-weight: 700;
    font-size: 12px;
    text-transform: uppercase;
    padding: 7px 10px;
}

.quittance-encadre-valeur {
    padding: 7px 10px;
    font-size: 13px;
}

.quittance-encadre-montant {
    text-align: right;
    font-weight: 700;
}

.quittance-engagement {
    margin-top: 16px;
    font-size: 13px;
    line-height: 1.9;
}

.quittance-engagement p {
    margin: 4px 0;
    text-align: justify;
}

.quittance-signatures {
    display: flex;
    justify-content: space-between;
    margin-top: 32px;
    gap: 24px;
}

.quittance-signature-col {
    flex: 1;
    text-align: center;
}

.quittance-signature-label {
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.5px;
    color: #1a6b3c;
    border-bottom: 1px solid #1a6b3c;
    padding-bottom: 4px;
    display: block;
}

.quittance-signature-space {
    height: 45px;
}

.quittance-footer {
    display: flex;
    justify-content: space-between;
    margin-top: 20px;
    font-size: 12px;
    border-top: 0.5px solid #a7f3d0;
    padding-top: 8px;
    color: #555;
}

.quittance-footer-dots {
    color: #1a6b3c;
    font-family: monospace;
}

@page {
    size: A4 portrait;
    margin: 0;
}

@media print {
    .quittance-container {
        width: 210mm;
        min-height: 297mm;
        padding: 12mm 15mm;
        margin: 0;
        box-shadow: none;
        font-size: 13px;
        -webkit-print-color-adjust: exact !important;
        print-color-adjust: exact !important;
    }
}

/* ── En-tete commun aux documents du Bureau ─────────────────────────────────
   Reproduit l'en-tete de l'offre CIMA (jsPDF) : trois colonnes, embleme au
   centre, filet vert. Voir EnteteDocumentBncb.js - les deux implementations
   sont a tenir en accord, elles ne partagent aucun code. */
.bncb-entete {
    margin-bottom: 14px;
}

.bncb-entete-accent {
    height: 3px;
    background: #1a6b3c;
    margin-bottom: 8px;
}

/* Les colonnes laterales partagent la meme base de largeur : l'embleme tombe
   ainsi au centre optique de la feuille, et non au milieu de ce qui reste une
   fois les titres poses. */
.bncb-entete-grille {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    padding-bottom: 8px;
    border-bottom: 1.2px solid #1a6b3c;
}

.bncb-entete-col {
    flex: 1 1 0;
    min-width: 0;
    text-align: center;
}

.bncb-entete-col--centre {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.bncb-entete-titre {
    font-size: 10.5px;
    font-weight: 700;
    line-height: 1.5;
    letter-spacing: .2px;
    color: #000;
    text-transform: uppercase;
}

.bncb-entete-logo {
    width: 62px;
    height: 62px;
    object-fit: contain;
}

.bncb-entete-legende {
    font-size: 7.5px;
    color: #8c8c8c;
    margin-top: 2px;
}

.bncb-entete-mention {
    text-align: right;
    font-size: 11px;
    color: #333;
    margin-top: 6px;
}

/* Les en-tetes de colonnes sont centres : une etiquette courte calee a gauche
   au-dessus d'une valeur large se lit comme si elle appartenait a la colonne
   precedente. */
.quittance-payment-table th {
    text-align: center;
}

/* Les prix sont soulignes : sur une decharge, ce sont les valeurs qu'on vient
   verifier, et le soulignement les designe sans les alourdir. */
.quittance-montant {
    text-decoration: underline;
    text-underline-offset: 2px;
}

/* De l'air avant les signatures : collees au dernier paragraphe, elles se
   lisaient comme la suite du texte plutot que comme un bloc a remplir. */
.quittance-signatures {
    margin-top: 54px;
}

/* ── Pied de page commun aux documents du Bureau ────────────────────────────
   Repris de l'offre CIMA : un filet gris, puis les coordonnees en petit.
   Voir PiedDocumentBncb.js. */
.bncb-pied {
    margin-top: 18px;
    padding-top: 6px;
    border-top: 0.6px solid #c8c8c8;
    text-align: center;
    font-size: 8px;
    line-height: 1.5;
    color: #969696;
}
`;
